import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { twMerge } from "tailwind-merge";

import { researchIdea } from "consts/urls";

const allBadges = [
  {
    id: "original",
    key: "isCommissioned",
    text: "Smartkarma Originals",
    message: (
      <>
        Exclusive research engaged by Smartkarma.{" "}
        <a href={researchIdea} target="_blank" className="text-smart-teal">
          Send us your research ideas
        </a>
      </>
    ),
    color: "#1c896e",
  },
  {
    id: "boost",
    key: "isBoost",
    text: "Boost Research",
    message: "Exclusive research from participants in the Boost programme",
    color: "#0276be",
  },
];

const PublicationBadges = ({ publication }: { publication: any }) => {
  const badges = allBadges
    .filter((badge) => publication[badge.key])
    .map((badge) => (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        key={badge.id}
        placement="right"
        delay={{ show: 0, hide: 2000 }}
        overlay={
          <Tooltip>
            <div className="text-left">{badge.message}</div>
          </Tooltip>
        }
      >
        <div
          style={{ backgroundColor: badge.color }}
          className={twMerge(
            "px-[4px] py-[2px]",
            "rounded-sm",
            "text-white text-[13px] font-bold leading-[1.2] whitespace-nowrap",
            "cursor-default"
          )}
        >
          {badge.text}
        </div>
      </OverlayTrigger>
    ));

  return <div className="flex space-x-[5px]">{badges}</div>;
};

export default PublicationBadges;
